import { AppRoutes } from "routers";

import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { useLoading } from "hook/useLoading";
import { Fragment } from "react";
import MoonLoader from "react-spinners/MoonLoader";
import { toast } from "react-toastify";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/Customizer/CustomizerProvider";
import "hook/mockApi"

// Tạo QueryCache với onError
const queryCache = new QueryCache({
  onError: (error, query) => {
    toast.error((error as any).response?.data?.message || "Có lỗi xảy ra");
  },
});

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      retry: 1, // Retry 1 lần
    },
  },
});

export const TheLoading = () => {
  const { isLoading } = useLoading();
  return isLoading ? (
    <div className="w-screen h-screen flex items-center justify-center app-overlay">
      <MoonLoader color="#7366ff" />
    </div>
  ) : (
    <Fragment />
  );
};

const App = () => {
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <TheLoading />
        <CustomizerProvider>
          <AnimationThemeProvider>
            <AppRoutes />
          </AnimationThemeProvider>
        </CustomizerProvider>
      </QueryClientProvider>
    </div>
  );
};

export default App;
